import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";



function MarketPlace() {
  const { t } = useTranslation();

  const {
    data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed },
  } = useSelector(({ walletSetting }) => walletSetting);

  const getMappedListRes = useSelector(
    ({ getMappedList }) => getMappedList
  );
  const Theme = useSelector((state) => state.theme.theme);

  const options = [
    {
      id: 1,
      label: "Customer Master",
      route: "/index/customer-master",
      src: `${process.env.PUBLIC_URL}/${Theme}/customer master.png`,
      flag: "CUSTOMER MASTER"
    },
    {
      id: 2,
      label: "Customer Wallet",
      route: "/index/customer-wallet",
      src: `${process.env.PUBLIC_URL}/${Theme}/MyWallets.png`,
      flag: "CREATE WALLET"
    },

    {
      id: 3,
      label: "Fee Wallet",
      route: "/index/fee-wallet",
      src: `${process.env.PUBLIC_URL}/${Theme}/Fee Wallet.png`,
      flag: "FEE WALLET"
    },

    {
      id: 4,
      label: "Manual OTP Request",
      route: "/index/manual-otp-request",
      src: `${process.env.PUBLIC_URL}/${Theme}/manual otp request.png`,
      flag: "OTP REQUEST",
    },
     {
      id: 5,
      label: 'Customer Bank',
      route: "/index/customer-bank",
      src: `${process.env.PUBLIC_URL}/${Theme}/MyBank.png`,
      flag: "CREATE WALLET"
    },

    {
      id: 6,
      label: 'Two Factor Authentication',
      route: "/index/two-fa-authentication",
      src: `${process.env.PUBLIC_URL}/${Theme}/twoFactorAuthentication.png`,
      flag: "TWO FACTOR AUTHENTICATION"
    },

      {
      id: 7,
      label: "Merchant Configuration",
      route: "/index/merchantconfiguration",
      src: `${process.env.PUBLIC_URL}/${Theme}/CREATE PROOF TYPE.png`,
      flag: "IP WHITELIST",
    },
     {
      id: 8,
      label: "Generate Link",
      route: "/index/generatelink",
      src: `${process.env.PUBLIC_URL}/${Theme}/generatelink.png`,
      flag: "GENERATE LINK",
    },
    
   
    

    // {
    //   id: 4,
    //   label: "Manual Upgrade Request",
    //   route: "/index/manual-upgrade-request",
    //   src: `${process.env.PUBLIC_URL}/${val.theme}/manual update request.png`,
    // },
    // {
    //   id: 4,
    //   label: "My Wallets",
    //   route: "/index/my-wallets",
    //   src: `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`,
    // },
  ];
  const history = useHistory();
  const { pathname } = useLocation();

  const filteredOptns = options.filter(({ label }) => {
    // if (
    //   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
    // ) {
    //   return label !== "My Cards";
    // }
    // else if (
    //   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
    // )
    // {
    //   return label !== "My Banks";
    // }
    if (
      label === "My Wallets" &&
      !constants.visibleFlags.includes(isMyWalletAllowed)
    ) {
      // return label !== "My Wallets";
    } else return true;
  });
  // .sort((a, b) => {
  //   return a.label > b.label ? 1 : -1;
  // });

  if (!filteredOptns.length) {
    return (
      <Layout>
        <Card className="mk-root">
          <Row className="mk-row m-auto">No My Accounts Available</Row>
        </Card>
      </Layout>
    );
  }

  const handleRoute = (route) => {
    history.push({ pathname: route, state: { from: pathname } });
  };

  return (
    <Layout>
      <Card className="mk-root">
        <Row className="mk-row text-center">
          {options.map(({ id, src, label, route, flag }) => {
            if (
              getMappedListRes.success &&
              getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
            ) {
              return (<Col key={id} md={4} sm={4} xs={6}>
                <div className="mk-imageRoot" onClick={() => handleRoute(route)}>
                  <div className="mk-imageContainer">
                    <img className="mk-image" src={src} alt={label} />
                  </div>
                  <Label for={label} className="fs-14">
                    {t(label)}
                  </Label>
                </div>
              </Col>)
            }
          })}
        </Row>
      </Card>
    </Layout>
  );
}

export default MarketPlace;
